import type { CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import { buildEmptySlot } from './empty-slot';

export interface WalletsGroupOpts {
  position: { left: number; top: number; height?: number };
  width?: number;
  slots?: number;
}

export function buildWalletsGroup(opts: WalletsGroupOpts): CanvasJSONLikeObject {
  const { position, width = 500, slots = 4 } = opts;
  const height = position.height ?? 50;
  return {
    type: 'Group',
    version: '7.1.0',
    pieceId: 'wallets',
    originX: 'center',
    originY: 'center',
    left: position.left,
    top: position.top,
    width,
    height,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    opacity: 1,
    visible: true,
    selectable: true,
    evented: true,
    subTargetCheck: false,
    interactive: false,
    objectCaching: false,
    groupCollection: {
      type: 'equispaced',
      direction: 'row',
      size: width,
      itemCrossSize: height,
      itemMainMax: 100,
      gap: 8,
      urlPath: 'imageUrl'
    },
    objects: Array.from({ length: slots }, () => buildEmptySlot({ width: 80, height: 40 }))
  };
}
